<template>
  <inventory-list
    :partId="partId"
    :crfqLineId="reqLineId"
    :gridId="gridId"
    isShowCreatePartInventory
  />
</template>

<script>

import { mapGetters } from 'vuex';

import InventoryList from '@/shared/components/InventoryList';
import { GRID_ID } from '@/shared/constants';

export default {
  props: {
    reqLineId: {
      type: [Number, String],
      default: 0
    },
    partId: {
      type: [Number, String],
      default: 0
    },
  },
  computed: {
    /*...mapGetters('requirements', [
      'selectedRequirement',
    ]),*/
    ...mapGetters('requirementAdd', [
      'currentPart',
    ]),
  },
  data: () => ({
    gridId: GRID_ID.INVENTORY_REQUIREMENTS_GRID,
  }),
  components: {
    InventoryList,
  },
};
</script>
